import images from "./assets";

export const listProduct = [
  {
    id: 1,
    name: "Thit bo",
    image: images.product1,
    price: 30,
  },
  {
    id: 2,
    name: "Chuoi",
    image: images.product2,
    price: 213,
  },
  {
    id: 3,
    name: "Oi",
    image: images.product3,
    price: 210,
  },
  {
    id: 4,
    name: "Dua hau",
    image: images.product4,
    price: 45,
  },
  {
    id: 5,
    name: "Nho",
    image: images.product5,
    price: 45,
  },
  {
    id: 6,
    name: "Banh",
    image: images.product6,
    price: 67,
  },
  {
    id: 7,
    name: "Tao",
    image: images.product7,
    price: 98,
  },
  {
    id: 8,
    name: "Xoai",
    image: images.product8,
    price: 54,
  },
];

export const listBlog = [
  {
    id: 1,
    title: "Cooking tips make cooking simple",
    desc: "Sed quia non numquam modi tempora indunt ut labore et dolore magnam aliquam quaerat",
    image: images.blog1,
  },
  {
    id: 2,
    title: "6 ways to prepare breakfast for 30",
    desc: "Sed quia non numquam modi tempora indunt ut labore et dolore magnam aliquam quaerat",
    image: images.blog2,
  },
  {
    id: 3,
    title: "Visit the clean farm in the US",
    desc: "Sed quia non numquam modi tempora indunt ut labore et dolore magnam aliquam quaerat",
    image: images.blog3,
  },
];
